import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { formatDateES, getMostRecentMonday, getCurrentDateTime } from '../utils/dateUtils';
import ProtectedEmail from './ProtectedEmail';
import styles from '../styles/Footer.module.css';

const Footer = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, school, student, logout } = useAuth();
  const lastUpdateDate = formatDateES(getMostRecentMonday());
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());
  
  // Debug auth state in footer
  useEffect(() => {
    console.log('[AUTH-DEBUG] Footer - Auth state:', {
      isAuthenticated,
      hasSchool: !!school,
      schoolName: school?.name,
      hasStudent: !!student,
      studentName: student?.name
    });
  }, [isAuthenticated, school, student]);

  // Update the time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(getCurrentDateTime());
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <footer className={`${styles.footer} ${isDarkMode ? styles.dark : ''}`}>
      <div className={styles.footerContent}>
        <p className={styles.updateInfo}>
          Preguntas actualizadas semanalmente desde <a href="https://transportes.gob.es" target="_blank" rel="noopener noreferrer">transportes.gob.es</a>.
          Última actualización: {lastUpdateDate}
        </p>
        
        <p className={styles.currentDateTime}>
          {currentDateTime}
        </p>
        
        <div className={styles.footerLinks}>
          <Link to="/aviso-legal">Aviso Legal</Link>
          <Link to="/privacidad">Política de Privacidad</Link>
          <ProtectedEmail email="contacto@examencap.es" linkText="Contacto" />
        </div>
        
        <div className={styles.sessionInfo}>
          {isAuthenticated ? (
            <>
              {student && (
                <small>
                  Estudiante: {student.name} -
                  <button
                    onClick={logout}
                    className={styles.logoutLink}
                  >
                    Desconectar
                  </button>
                </small>
              )}
              {school && (
                <small>
                  Autoescuela: {school.name} -
                  <button
                    onClick={logout}
                    className={styles.logoutLink}
                  >
                    Desconectar
                  </button>
                </small>
              )}
            </>
          ) : (
            <small>Usuario no conectado</small>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;